module.exports = __webpack_public_path__ + "img/p3.887040bf.jpg";